var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.5,
    height: 15.5,
    viewBox: "0 0 15.5 15.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "help-circle",
    transform: "translate(0.75 0.541)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_385",
    "data-name": "Ellipse 385",
    cx: 7,
    cy: 7,
    r: 7,
    transform: "translate(0 0.209)",
    fill: "none",
    stroke: "var(--theme-text)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_728",
    "data-name": "Path 728",
    d: "M9.09,8.42a2.131,2.131,0,0,1,4.142.71c0,1.421-2.131,2.131-2.131,2.131",
    transform: "translate(-4.053 -3.446)",
    fill: "none",
    stroke: "var(--theme-text)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_78",
    "data-name": "Line 78",
    transform: "translate(7 10.209)",
    fill: "none",
    stroke: "var(--theme-text)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpSmall);
export default __webpack_public_path__ + "static/media/helpSmall.90109c37e31e12976bed5ce25d1f7b5f.svg";
export { ForwardRef as ReactComponent };